<template>
  <div class="container container-builder">
    <div class="card bonds">
      <div class="card-header text-dark d-flex justify-content-between font-weight-bold">
        Equipos
        <span class="geodir-icon-team"></span>
      </div>
      <span class="geodir-icon-arrow-down-01 arr"></span>
      <select v-model="teamSelected" class="form-control form-control-sm">
        <option value selected data-default disabled>Seleccione Equipo</option>
        <option
          v-for="_team in builder._teams"
          v-bind:value="_team.team"
          @click="changeTeamUI()"
        >{{_team.teamName}}</option>
      </select>
    </div>
    <br/>

    <div class="card bonds">
      <div class="card-header text-dark d-flex justify-content-between font-weight-bold">
        Mapas
        <span class="geodir-icon-map"></span>
      </div>
      <span class="geodir-icon-arrow-down-01 arr"></span>
      <select v-model="mapSelected" class="form-control form-control-sm">
        <option value selected data-default disabled>Seleccione Mapa</option>
        <option v-for="_map in builder._maps" v-bind:value="_map.mapa">{{_map.name}}</option>
      </select>
    </div>
    <br/>

    <div class="card">
      <div class="card-header text-dark d-flex justify-content-between font-weight-bold">
        Capas
        <span
          class
          v-bind:class="infoClass(builder._info)"
          v-if="Object.keys(builder._layers).length > 0"
        />
        <span class="geodir-icon-layers"></span>
      </div>
      <ul class="list-group list-group-flush" v-if="builder._layers">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
          v-for="(_layer,index) in builder._layers"
        >
          <div class="col-10 pl-0">{{ _layer.alias }}</div>
          <div class="row" style="flex-wrap: nowrap !important;margin-top: 0.3rem !important;">
            <div class="col-md-auto list-items">
              <span class v-bind:class="visbleClass(_layer.visible)" @click="changeVisible(_layer)"></span>
            </div>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
const builderHost = process.env.VUE_APP_BUILDER_HOST;

require("@geodir/geodir-js/src/Geodir");
var _geo = new Geodir();
require("@geodir/geodir-js/src/GeodirBuilder");
var ghRequest = new GeodirBuilder({ host: builderHost });

//agregar librerias WMS

require('../../assets/js/managerMap/L.TileLayer.GeodirWMS');
const $ = require('jquery');


import {mapState ,mapMutations} from 'vuex'

export default {
  data() {
    return {
      builder: {
        _teams: [],
        _maps: [],
        _map: null,
        _controlLayer: null,
        _layers: [],
        _layersMap: {
          baseLayers: {},
          overlays: {}
        },
        _layerSelected: null,
        _indexLayerInfo: -1,
        _info: true,
        _layersInfo: [],
        _table_columns: {}
      },
      teamSelected: null,
      mapSelected: this.$route.query.mapa,
      isloadingMaps: false,
      layerResult: null,
      _centerMap: null,
      geometriaOfClick: null
    };
  },
  props: ["map"],
  created() {
    console.log("COMPONENTE BUILDER creado");
    if(this.checkLogin){
        let token = JSON.parse(localStorage.getItem("geodir_Token"));
        _geo.setAccessToken(token.data.access_token);
    }

    this.initBuilder();
  },
  /*computed:{
    ...mapState(['map'])
  },*/
  watch: {
    //Cuando cambia team seleccionado
    teamSelected: function(newVal, oldVal) {
      var that = this;
      if (oldVal != null) {
        that.isloadingMaps = false;
      }
      this.listMaps(this.teamSelected)
        .then(resp => {
          that.builder._maps = [...resp];
          if (!that.isloadingMaps) {
            that.removeAllLayers().then(res => {
              that.builder._layers = [];
              that.builder._layersMap = {
                baseLayers: {},
                overlays: {}
              };
              this.$router.push({ query: {} });
            });
          }
          that.isloadingMaps = false;
        })
        .catch();
    },

    //Cuando cambia la ruta
    $route: function() {
      console.log('CAMBIO LA RUTA');
      this.mapSelected = this.$route.query.mapa;
      this.$store.commit("SET_MAP_SELECT", this.mapSelected);
    },

    //Cuando cambiamos el mapa
    mapSelected: function() {
      console.log('cambio el mapa');
      //Mandar a la url el mapa seleccionado
      this.$router.push({ query: { mapa: this.mapSelected } });
      this.isloadingMaps = false;
      //remover las capas
      this.removeAllLayers().then(res => {
        //busMainMap.initBuilder(this.mapSelected);
        console.log('SELECCIONAR MAPA');
        console.log(this.mapSelected);
        this.initBuilderMap(this.mapSelected);
      });
    }
  },
  methods: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    initBuilder: function() {
      console.log("iniciar builder");
      this.builder._map = this.map;
      if (this.checkLogin()) {
        this.listTeams().then(resp => {
          if (this.mapSelected) {
            this.initBuilderMap(this.mapSelected);
            this.$store.commit("SET_MAP_SELECT", this.mapSelected);
          }
        });
      }
    },

    initBuilderMap: function(map) {
      var that = this;
      this.getLayers(map)
        .then(layers => {
          that.teamSelected = layers.team.team;
          that.isloadingMaps = true;
          this.removeAllLayers().then(resp => {
            this.builder._table_columns = layers.table_columns;

            this.builder._layers = layers.layers;
            console.log("ASIGNAR CAPA");

            this.addLayersToMap();
            this.getConfig();
          });
        })
        .catch(resp => {
          this.$router.push({ query: { mapa: undefined } });
        });
    },
    getLayers: function(mapSelected) {
      let promise = new Promise((res, rej) => {
        if (mapSelected) {
          ghRequest
            .getLayersByMap(mapSelected)
            .then(response => {
              const resp = response;
              resp.table_columns = {};
              for (let i in resp.layers) {
                let columns = resp.columns[resp.layers[i].id];
                resp.table_columns[resp.layers[i].layerTable.name] = columns;
              }
              res(resp);
            })
            .catch(error => {
              rej(error);
            });
        }
      });
      return promise;
    },
    getConfig: function() {
      var that = this;
      ghRequest
        .getMapConfig(that.mapSelected)
        .then(results => {
          if (that.mapSelected) {
            that._centerMap = results.center;
            var code = that._centerMap.split(",");
            var lat = code[0].replace("[", "").replace(" ", "");
            var lng = code[1].replace("]", "").replace(" ", "");
            that._zoomMap = results.zoom;
            that.builder._map.flyTo([lat, lng], that._zoomMap);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeTeamUI: function() {
      this.isloadingMaps = false;
    },
    changeTeam: function(team) {
      return this.listMaps(this.teamSelected);
    },
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    changeLayersInfo: function() {
      if (this.builder._info) {
        this.builder._map.on("click", this.getFeaturesInfo, this);
      } else {
        this.builder._map.off("click", this.getFeaturesInfo, this);
      }
    },

    listTeams: function() {
      var that = this;
      this.builder._teams = [];
      let promise = new Promise((res, rej) => {
        ghRequest
          .getTeams()
          .then(response => {
            const resp = response;
            that.builder._teams = [...resp];
            console.warn("TEAMSSSSSSSSSSSSS");
            console.log(that.builder._teams);
            res(resp);
          })
          .catch(error => {
            rej(error);
          });
      });
      return promise;
    },
    listMaps: function(teamSelected) {
      let promise = new Promise((res, rej) => {
        if (teamSelected) {
          ghRequest
            .getMapsbyTeam(teamSelected)
            .then(response => {
              const resp = response;
              res(resp);
            })
            .catch(error => {
              rej(error);
            });
        }
      });
      return promise;
    },
    addLayersToMap: function() {
      console.log('AGREGAR CAPAS AL MAPA');
      console.log(this.builder._map);
      if (this.builder._map) {
        let cont = 0;
        let layers = this.builder._layers;
        for (let layer in layers) {
          let _zIndex = 15 + layers[layer].order;
          let _urlLayer = layers[layer].wmsUrl;

          var _wmsLayer = null;

          console.log("LAYER");
          console.log(layers[layer]);
          if (layers[layer].tiled) {
            _wmsLayer = L.tileLayer.geodirWMS(_urlLayer, {
              name: layers[layer].alias,
              layers: layers[layer].layer,
              nikolasParam: Math.random(),
              sld: layers[layer].sld,
              maxZoom: 19,
              format: "image/png",
              transparent: true,
              tiled: true,
              crs: L.CRS.EPSG4326,
              CQL_FILTER: layers[layer].query,
              columnId: layers[layer].layerTable.pk,
              zIndex: _zIndex
            });
          } else {
            _wmsLayer = L.TileLayer.geodirHeatMap(layers[layer].wmsUrl, {
              name: layers[layer].alias,
              layers: layers[layer].layer,
              nikolasParam: Math.random(),
              sld: layers[layer].sld,
              maxZoom: 19,
              format: "image/png",
              transparent: true,
              tiled: false,
              CQL_FILTER: layers[layer].query,
              columnId: layers[layer].layerTable.pk
              //zIndex: _zIndex
            });
          }

          let _layer = {
            data: layers[layer],
            layer: _wmsLayer
          };

          this.builder._layersMap.overlays[layers[layer].id] = _layer;

          if (_layer.data.geometryType == "Polygon") {
            this.$store.commit("SET_LAYER_SELECT", _layer);
          }

          if (layers[layer].visible) {
            this.builder._map.addLayer(_layer.layer);
          }

          if (this.builder._controlLayer) {
            this.builder._controlLayer.addOverlay(
              _layer.layer,
              _layer.data.alias
            );
          }
          cont++;
          if (cont == Object.keys(this.builder._layers).length) {
            this.getInfoLayers();
          }
        }
      }
    },

    ejecutardataquality: function() {
      console.log("Ejecutar data quality");
    },

    createPopUp: function(latlgn, dataPopUp) {
      console.log("Create popup");
      console.log(dataPopUp);

      var ubicaionpopup = latlgn;
      var popupRetorno;
      var divCarrousel = null;
      var popupCarrousel = null;
      var popup_general = null;
      var back_popup = null;
      var next_popup = null;
      var popup_content = null;
      var haveMoreOneFeature = false;
      var isshow = false;

      /**
       * Crear contenedor de la tabla de datos
       */
      if (dataPopUp.length > 1) {
        //console.log('tiene mas de un elemento');
        divCarrousel = L.DomUtil.create("div", "carousel slide");
        divCarrousel.setAttribute("data-ride", "carousel");
        divCarrousel.setAttribute("id", "carouselSigvial");
        divCarrousel.setAttribute(
          "style",
          "margin: 0px -20px; margin-right: -26px;"
        );

        var carrouselIndicators = L.DomUtil.create("div", "", divCarrousel);
        carrouselIndicators.setAttribute("id", "slidetext");
        carrouselIndicators.style =
          "width:100%; height:20px; text-align:center; font-weight: bold;";

        popupCarrousel = L.DomUtil.create(
          "div",
          "carousel-inner",
          divCarrousel
        );
        popupCarrousel.setAttribute("role", "listbox");

        back_popup = L.DomUtil.create(
          "a",
          "carousel-control-prev",
          divCarrousel
        );
        back_popup.setAttribute("href", "#carouselSigvial");
        back_popup.setAttribute("role", "button");
        back_popup.setAttribute("data-slide", "prev");
        var span_back = L.DomUtil.create(
          "span",
          "geodir-icon-back_02",
          back_popup
        );

        next_popup = L.DomUtil.create(
          "a",
          "carousel-control-next",
          divCarrousel
        );
        next_popup.setAttribute("href", "#carouselSigvial");
        next_popup.setAttribute("role", "button");
        next_popup.setAttribute("data-slide", "next");
        var span_next = L.DomUtil.create(
          "span",
          "geodir-icon-next-02",
          next_popup
        );

        haveMoreOneFeature = true;
        popupRetorno = divCarrousel;
      } else {
        //console.log('tiene un elemento');

        //Cuando tiene solo un elemento
        popup_general = L.DomUtil.create("div", "");
        popup_content = L.DomUtil.create("div", "", popup_general);
        popup_general.style =
          "max-width: 300px; max-height: 250px;overflow:auto;";
        popupRetorno = popup_general;
      }

      /**
       * Crear contenido
       */
      for (var i = 0; i < dataPopUp.length; i++) {
        // Tiene mas de un elemento
        if (haveMoreOneFeature) {
          if (i == 0) {
            //primer valor
            var carrouselItem = L.DomUtil.create(
              "div",
              "carousel-item active",
              popupCarrousel
            );
          } else {
            //siguientes valores
            var carrouselItem = L.DomUtil.create(
              "div",
              "carousel-item",
              popupCarrousel
            );
          }
          let numbberItem = i + 1;
          carrouselItem.id = "slide" + numbberItem;

          //insertar div con clase container
          var popup_general = L.DomUtil.create(
            "div",
            "container",
            carrouselItem
          );
          var popup_content = L.DomUtil.create(
            "div",
            "form-group",
            popup_general
          );

          popup_general.style =
            "max-width: 250px; width: 250px; overflow:auto;padding: 5px 15px !important;";
          popup_content.style =
            "max-height:208px; overflow:auto; margin: 0 15px;";
        }

        // insertar tabla de datos
        var popup_table = L.DomUtil.create("table", "tblDatos", popup_content);
        for (var j in dataPopUp[i].info.columns) {
          var col = dataPopUp[i].info.columns[j];
          var nombreAtributo = col.alias;
          var valorAtr = dataPopUp[i].info.data[j] + "";
          var valorAtributo = valorAtr
            .replace(/Ã±/g, "&ntilde;")
            .replace(/â€“/g, "–")
            .replace(/ï»¿/g, "-");
          var isurl = this.isUrlValidToputlink(valorAtributo);
          if (isurl) {
            popup_table.appendChild(
              this.totrTableUrl(nombreAtributo, valorAtributo)
            );
          } else {
            valorAtributo = valorAtributo.replace("null", "");
            popup_table.appendChild(
              this.totrTable(nombreAtributo, valorAtributo)
            );
          }
        }

        /*var createPopup = false;
        if (this.geometriaOfClick.type == "Polygon") {
          createPopup = true;
          var btn_data_quality = L.DomUtil.create(
            "button",
            "btnEdit",
            popup_general
          );
          btn_data_quality.innerHTML =
            '<img data-v-316e6666="" src="/src/assets/images/quality/data.svg" width="20" height="20"> Data-Quality';
          btn_data_quality.setAttribute("id", "btnquality");
          btn_data_quality.setAttribute(
            "class",
            "btn btn-outline-primary mt-3"
          );
        }*/

      }

      for (var item in dataPopUp) {
        if (item == 0) {
          var popup = L.popup({
            maxWidth: "500",
            className: "custom-popup",
            autoPan: "true"
          })
            .setLatLng(ubicaionpopup)
            .setContent(popupRetorno)
            .openOn(this.builder._map);
        }
      }

      //cantidad de popups
      var totalItems = $(".carousel-item").length;
      var currentIndex = $("div.active").index() + 1;

      $("#slidetext").html("" + currentIndex + "/" + totalItems + "");

      $(".carousel").on("slide.bs.carousel", function(e) {
        currentIndex = e.relatedTarget.id.replace("slide", "");
        $("#slidetext").html("" + currentIndex + "/" + totalItems + "");
      });

      //fin crear popup
      if (createPopup) {
        document
          .getElementById("btnquality")
          .addEventListener("click", this.ejecutarqualitt);
      }
    },

    ejecutarqualitt: function() {
      var geojsonvalue = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: this.geometriaOfClick.type,
              coordinates: this.geometriaOfClick.coordinates
            }
          }
        ]
      };

      var geojson = new L.GeoJSON(geojsonvalue, {
        style: function(feature) {
          return { color: "red" };
        }
      });

      this.$emit("on-data-quality", geojson);
    },

    totrTable: function(nombreAtributo, valorAtributo) {
      var tr = L.DomUtil.create("tr", "");
      var td = L.DomUtil.create("td", "", tr);
      var divAtributo = L.DomUtil.create("div", "atributo", td);
      divAtributo.innerHTML = nombreAtributo;
      var divvalor = L.DomUtil.create("div", "valor", td);
      divvalor.innerHTML = valorAtributo;
      return tr;
    },

    totrTableUrl: function(nombreAtributo, valorAtributo) {
      var tr = L.DomUtil.create("tr", "");
      var td = L.DomUtil.create("td", "", tr);
      var divAtributo = L.DomUtil.create("div", "atributo", td);
      divAtributo.innerHTML = nombreAtributo;
      var divvalor = L.DomUtil.create("div", "valor", td);
      var a = L.DomUtil.create("a", "", divvalor);
      a.href = valorAtributo;
      a.target = "_blank";
      return tr;
    },

    isUrlValidToputlink: function(userInput) {
      var res = userInput.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      if (res == null) return false;
      else return true;
    },
    getGroupFeatureInfo(evt, _layers, filters) {
      _layers.reverse();
      filters.reverse();
      let url = this.getGroupFeatureInfoUrl(evt.latlng, _layers, filters);
      let promise = new Promise((res, rej) => {
        $.ajax({
          url: url,
          type: "GET",
          dataType: "JSONP",
          jsonpCallback: "parseResponse",
          success: function(data, status, xhr) {
            res(data);
          },
          error: function(xhr, status, error) {
            res(null);
          }
        });
      });
      return promise;
    },
    getGroupFeatureInfoUrl: function(latlng, layers, filters) {
      var map = this.builder._map;
      let _filters = filters.toString().replace(",", ";");
      var point = map.latLngToContainerPoint(latlng, map.getZoom());
      let size = map.getSize();
      let params = {
        request: "GetFeatureInfo",
        service: "WMS",
        srs: "EPSG:4326",
        version: "1.1.1",
        bbox: map.getBounds().toBBoxString(),
        height: size.y,
        width: size.x,
        layers: layers.toString(),
        FEATURE_COUNT: 10,
        query_layers: layers.toString(),
        info_format: "text/javascript",
        EXCEPTIONS: "application/vnd.ogc.se_xml",
        CQL_FILTERS: _filters
      };

      params[params.version === "1.3.0" ? "i" : "x"] = point.x;
      params[params.version === "1.3.0" ? "j" : "y"] = point.y;

      var url = this.wms_geoserver;
      return url + L.Util.getParamString(params, url, true);
    },
    getFeaturesInfo: function(event) {
      console.log("OBTENER INFORMACION");

      this.builder._layersInfo = [];
      let promises = [];
      let _layers = [];
      let _cqlFilters = [];
      let idLayer = null;
      for (let index in this.builder._layers) {
        let _layer = this.builder._layers[index];
        if (_layer.visible) {
          _layers.push(this.builder._layers[index].layer);
          _cqlFilters.push(this.builder._layers[index].query);
          idLayer = _layer.id;
          this.wms_geoserver = _layer.wmsUrl;
        }
      }
      if (idLayer) {
        this.builder._map._container.style.cursor = "wait";
        this.getGroupFeatureInfo(event, _layers, _cqlFilters)
          .then(data => {
            let dataPopUp = [];
            if (data.features) {
              for (let index in data.features) {
                var layerName = data.features[index].id.substring(
                  0,
                  data.features[index].id.indexOf(".")
                );
                var columns_table = this.builder._table_columns[layerName];
                var info = {
                  columns: columns_table,
                  data: data.features[index].properties
                };
                dataPopUp.push({ alias: layerName, info: info });

                console.log("EXTRAER INFORMACION");
                console.log(data.features[index].geometry);
                this.geometriaOfClick = data.features[index].geometry;
              }

              this.createPopUp(event.latlng, dataPopUp);
              this.builder._map._container.style.cursor = "auto";
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    buildLayersPopup: function() {
      console.log("info", this.builder._layersInfo);
    },

    getInfoLayers: function() {
      this.changeLayersInfo();
      let layers = this.builder._layers;
    },
    changeInfo: function(layer) {
      if (this.builder._layerSelected) {
        this.builder._layerSelected.disableInfo();
      }
      if (this.builder._indexLayerInfo > -1) {
        this.builder._indexLayerInfo = -1;
      } else {
        this.builder._indexLayerInfo = layer.id;
        this.builder._layerSelected = this.builder._layersMap.overlays[
          this.builder._indexLayerInfo
        ]["layer"];
        let thatlayer = this.builder._layerSelected;
      }
    },
    changeVisible: function(layer) {
      let id = layer.id;
      if (!layer.visible) {
        this.builder._map.addLayer(
          this.builder._layersMap.overlays[id]["layer"]
        );
      } else {
        this.builder._map.removeLayer(
          this.builder._layersMap.overlays[id]["layer"]
        );
      }
      layer.visible = !layer.visible;
    },
    visbleClass: function(isVisible) {
      return {
        "geodir-icon-on": isVisible,
        "geodir-icon-off": !isVisible
      };
    },

    removeAllLayers: function() {
      let promise = new Promise((res, rej) => {
        let layers = this.builder._layers;
        let layerRemove = this.builder._layersMap.overlays;
        for (let id in layerRemove) {
          this.builder._map.removeLayer(layerRemove[id].layer);
          this.builder._controlLayer.removeLayer(layerRemove[id].layer);
        }
        res({ status: "ok" });
      });
      return promise;
    },

    infoClass: function(val) {
      //console.log('val', val);
      if (val) {
        return {
          "geodir-icon-si-info": true,
          "geodir-icon-no-info": false
        };
      } else {
        return {
          "geodir-icon-si-info": false,
          "geodir-icon-no-info": true
        };
      }
    }
  }
};
</script>
<style scoped>

.container-builder{
  font-size: 13px;
}

.card-header span:before {
  font-size: 20px;
  font-weight: bold;
}
.card-header span {
  margin-right: 10px;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #009effad !important;
  border-color: #009effad !important;
}
.list-group-item span:before {
  font-size: 20px;
}
.list-group-item span {
  margin-right: 15px;
}
.list-group-item.active span:before {
  color: #fff !important;
}
.bonds {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);
}
.bonds select {
  -webkit-appearance: none;
}

.bonds .arr {
  bottom: 23px;
  position: absolute;
  right: 0;
  width: 25px;
  pointer-events: none;
  font-size: 18px;
}

.list-items {
  padding: 0px !important;
  padding-right: 15px !important;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #ced4da !important;
  outline: 0;
  box-shadow: none !important;
}
tr td:nth-child(1) .valor {
  font-size: 16px !important;
}
.list-group-item {
  padding: 0.2rem 1.25rem !important;
}


/* PARA LA LISTA */
	.settings-list {
	    border-top: 1px solid #d9d9d9;
	    font-size: 13px;
	    cursor: pointer;
	}
	.settings-header {
	    padding: 15px 20px;
	}
	.settings-list {
	    padding: 15px 10px;
	}
	.settings-list-item span:before {
	    font-size: 22px;
	    margin-top: 6px;
	}




</style>


